import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Reveal } from "@/components/Motion";
import { getSortedArticles } from "@/data/articles";

export default function Journal() {
  const articles = getSortedArticles();
  return (
    <div className="pt-32 pb-24 min-h-screen" style={{ backgroundColor: "#0A0A12" }} data-testid="journal-page">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <Reveal className="max-w-3xl mb-20">
          <p className="text-xs uppercase tracking-luxe mb-6" style={{ color: "#C9A96E" }}>
            Le Journal Souverain
          </p>
          <h1 className="font-serif text-5xl md:text-7xl leading-[0.95] text-white">
            Savoirs, méditations & <span style={{ color: "#C9A96E" }}>architecture de vie</span>.
          </h1>
          <p className="text-white/60 font-light text-lg mt-8 leading-relaxed">
            Chroniques de l'Académie AETHERIS — pour transformer la connaissance millénaire
            en gestes de Réédification quotidienne.
          </p>
        </Reveal>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {articles.map((a, i) => (
            <Reveal key={a.slug} delay={i * 0.1}>
              <Link
                to={`/journal/${a.slug}`}
                data-testid={`article-card-${a.slug}`}
                className="group block h-full border border-white/10 hover:border-[#C9A96E]/60 transition-colors duration-500"
                style={{ backgroundColor: "#111119" }}
              >
                <div className="overflow-hidden">
                  <img
                    src={a.banner}
                    alt={a.bannerAlt || a.title}
                    onError={(e) => { if (e.currentTarget.src !== window.location.origin + "/journal-banner.jpg") e.currentTarget.src = "/journal-banner.jpg"; }}
                    className="w-full h-56 object-cover opacity-85 group-hover:opacity-100 group-hover:scale-105 transition-all duration-700 ease-out"
                  />
                </div>
                <div className="p-7">
                  <p className="text-xs uppercase tracking-luxe mb-3" style={{ color: "#C9A96E" }}>
                    {a.category}
                  </p>
                  <h2 className="font-serif text-2xl leading-snug text-white group-hover:text-[#C9A96E] transition-colors">
                    {a.title}
                  </h2>
                  <p className="text-sm text-white/40 mt-3">{a.date} — {a.author}</p>
                  <p className="text-white/60 font-light leading-relaxed mt-4 line-clamp-4">
                    {a.excerpt}
                  </p>
                  <span className="mt-5 inline-flex items-center gap-1 text-sm group-hover:gap-2 transition-all" style={{ color: "#C9A96E" }}>
                    Lire l'article <ArrowUpRight size={15} />
                  </span>
                </div>
              </Link>
            </Reveal>
          ))}
        </div>
      </div>
    </div>
  );
}
